import events from 'Assets/js/components/events';
import rateLimit from 'axios-rate-limit';
import globalTheme from "Assets/js/components/globalTheme";

const triggerErrorLog = (error) => {
  axios.post('/wp-json/teams/v1/send', {
    error: { 'service: ': 'productService', error }
  });
};

function ProductServiceConstructor() {
  const checkProduct = (callback = undefined) => {
    const start = performance.now();

    if (
      typeof callback === 'function' &&
      window.MDC_PRODUCT_OBJECT !== undefined
    ) {
      const end = performance.now();
      callback(window.MDC_PRODUCT_OBJECT);
    }
  }

  return {
    checkProduct,
    events: () => events
  };
}

const productService = (() => {
  const instance = new ProductServiceConstructor();
  return {
    getInstance: () => instance
  };
})();

export default productService;
